// 观星 · 天体名称简体中文翻译表
//
// 用途：sw_helpers.js 的 translateFn（引擎 sys_translate 回调）按域查表：
//   - domain "skyculture"：星座名（western/index.json 的 native 拉丁名）与
//     恒星专名（AT-HYG proper，经 skydata common_names 进入引擎名称哈希）
//   - domain "sky"：太阳系天体名（引擎 planets.ini 生成，首字母大写）
//
// 来源与口径：
//   - 星座名与 public/data/constellations.json 产物一致
//     （d3-celestial 繁体经 pipeline/build-constellations.mjs 字表转简体，
//     Sagittarius=人马座、Virgo=处女座、Aquarius=宝瓶座 等沿用该口径）；
//     Canes Venatici / Triangulum Australe 因 d3-celestial 缩写大小写差异
//     （CVn/TrA vs Cvn/Tra）未进自动映射，此处手工补齐，值仍取自产物。
//   - 恒星专名为 IAU 星名通行中文译名（手工精选，约 90 颗；未收录的
//     专名回退显示英文原名，不做机翻）。

// 星座：native 拉丁名 → 简体中文（88 个全覆盖）
export const CONSTELLATION_ZH = {
  Aquila: '天鹰座',
  Andromeda: '仙女座',
  Sculptor: '玉夫座',
  Ara: '天坛座',
  Libra: '天秤座',
  Cetus: '鲸鱼座',
  Aries: '白羊座',
  Scutum: '盾牌座',
  Pyxis: '罗盘座',
  Bootes: '牧夫座',
  Caelum: '雕具座',
  Chamaeleon: '蝘蜒座',
  Cancer: '巨蟹座',
  Capricornus: '摩羯座',
  Carina: '船底座',
  Cassiopeia: '仙后座',
  Centaurus: '半人马座',
  Cepheus: '仙王座',
  'Coma Berenices': '后发座',
  Auriga: '御夫座',
  Columba: '天鸽座',
  Circinus: '圆规座',
  Crater: '巨爵座',
  'Corona Australis': '南冕座',
  'Corona Borealis': '北冕座',
  Corvus: '乌鸦座',
  Crux: '南十字座',
  Cygnus: '天鹅座',
  Delphinus: '海豚座',
  Dorado: '剑鱼座',
  Draco: '天龙座',
  Norma: '矩尺座',
  Eridanus: '波江座',
  Sagitta: '天箭座',
  Fornax: '天炉座',
  Gemini: '双子座',
  Camelopardalis: '鹿豹座',
  'Canis Major': '大犬座',
  'Ursa Major': '大熊座',
  Grus: '天鹤座',
  Hercules: '武仙座',
  Horologium: '时钟座',
  Hydra: '长蛇座',
  Hydrus: '水蛇座',
  Indus: '印第安座',
  Lacerta: '蝎虎座',
  Monoceros: '麒麟座',
  Lepus: '天兔座',
  Leo: '狮子座',
  Lupus: '豺狼座',
  Lynx: '天猫座',
  Lyra: '天琴座',
  Antlia: '唧筒座',
  Microscopium: '显微镜座',
  Musca: '苍蝇座',
  Octans: '南极座',
  Apus: '天燕座',
  Ophiuchus: '蛇夫座',
  Orion: '猎户座',
  Pavo: '孔雀座',
  Pegasus: '飞马座',
  Pictor: '绘架座',
  Perseus: '英仙座',
  Equuleus: '小马座',
  'Canis Minor': '小犬座',
  'Leo Minor': '小狮座',
  Vulpecula: '狐狸座',
  'Ursa Minor': '小熊座',
  Phoenix: '凤凰座',
  Pisces: '双鱼座',
  'Piscis Austrinus': '南鱼座',
  Volans: '飞鱼座',
  Puppis: '船尾座',
  Reticulum: '网罟座',
  Sagittarius: '人马座',
  Scorpius: '天蝎座',
  Serpens: '巨蛇座',
  Sextans: '六分仪座',
  Mensa: '山案座',
  Taurus: '金牛座',
  Telescopium: '望远镜座',
  Tucana: '杜鹃座',
  Triangulum: '三角座',
  Aquarius: '宝瓶座',
  Virgo: '处女座',
  Vela: '船帆座',
  'Canes Venatici': '猎犬座',
  'Triangulum Australe': '南三角座'
}

// 太阳系天体：引擎名 → 简体中文（domain "sky"）
export const SOLAR_ZH = {
  Sun: '太阳',
  Moon: '月球',
  Mercury: '水星',
  Venus: '金星',
  Earth: '地球',
  Mars: '火星',
  Jupiter: '木星',
  Saturn: '土星',
  Uranus: '天王星',
  Neptune: '海王星',
  Pluto: '冥王星',
  Io: '伊娥',
  Europa: '欧罗巴',
  Ganymede: '盖尼米德',
  Callisto: '卡里斯托',
  Titan: '泰坦',
  Phobos: '火卫一',
  Deimos: '火卫二'
}

// [guanxing patch] M-QZ：七政传统星官名（开关开启时画布行星标签用此表，
//  关闭恢复 SOLAR_ZH 现代名）。口径：岁星=木、荧惑=火、镇星=土、
//  太白=金、辰星=水，日月沿用本字。
export const SOLAR_TRAD = {
  Sun: '日',
  Moon: '月',
  Mercury: '辰星',
  Venus: '太白',
  Mars: '荧惑',
  Jupiter: '岁星',
  Saturn: '镇星'
}

// 引擎线名标签：lines.c 的线名经 sys_translate("gui", …) 出现在画布上
// （黄道线/子午线/天赤道的名称标注；M-SW3h 起黄道线可由图层菜单开启）
export const GUI_ZH = {
  Ecliptic: '黄道',
  Meridian: '子午线',
  Equator: '天赤道'
}

// 恒星专名：AT-HYG proper → IAU 通行中文译名（domain "skyculture"）
export const STAR_ZH = {
  Sirius: '天狼星',
  Canopus: '老人星',
  'Rigil Kentaurus': '南门二',
  Arcturus: '大角星',
  Vega: '织女一',
  Capella: '五车二',
  Rigel: '参宿七',
  Procyon: '南河三',
  Achernar: '水委一',
  Betelgeuse: '参宿四',
  Hadar: '马腹一',
  Altair: '河鼓二',
  Acrux: '十字架二',
  Aldebaran: '毕宿五',
  Antares: '心宿二',
  Spica: '角宿一',
  Pollux: '北河三',
  Fomalhaut: '北落师门',
  Deneb: '天津四',
  Mimosa: '十字架三',
  Regulus: '轩辕十四',
  Adhara: '弧矢七',
  Castor: '北河二',
  Gacrux: '十字架一',
  Shaula: '尾宿八',
  Bellatrix: '参宿五',
  Elnath: '五车五',
  Miaplacidus: '南船五',
  Alnilam: '参宿二',
  Alnair: '鹤一',
  Alnitak: '参宿一',
  Mintaka: '参宿三',
  Alioth: '玉衡',
  Dubhe: '天枢',
  Merak: '天璇',
  Phecda: '天玑',
  Megrez: '天权',
  Alcor: '辅',
  Mizar: '开阳',
  Alkaid: '摇光',
  Mirfak: '天船三',
  Wezen: '弧矢一',
  Sargas: '尾宿五',
  'Kaus Australis': '箕宿三',
  'Kaus Media': '箕宿二',
  'Kaus Borealis': '箕宿一',
  Avior: '海石一',
  Aspidiske: '海石二',
  Menkent: '库楼三',
  Atria: '三角形三',
  Alhena: '井宿三',
  Peacock: '孔雀十一',
  Mirzam: '军市一',
  Alphard: '星宿一',
  Polaris: '北极星',
  Hamal: '娄宿三',
  Algieba: '轩辕十二',
  Diphda: '土司空',
  Nunki: '斗宿四',
  Menkalinan: '五车三',
  Mirach: '奎宿九',
  Alpheratz: '壁宿二',
  Rasalhague: '侯',
  Kochab: '北极二',
  Pherkad: '北极一',
  Saiph: '参宿六',
  Denebola: '五帝座一',
  Algol: '大陵五',
  Caph: '王良一',
  Schedar: '王良四',
  Ruchbah: '阁道三',
  Segin: '阁道二',
  Navi: '策',
  Cih: '策',
  Eltanin: '天棓四',
  Markab: '室宿一',
  Scheat: '室宿二',
  Algenib: '壁宿一',
  Enif: '危宿三',
  Alrescha: '外屏七',
  'Deneb Algedi': '垒壁阵四',
  Zubenelgenubi: '氐宿一',
  Zubeneschamali: '氐宿四',
  Thuban: '右枢',
  Alphecca: '贯索四',
  Izar: '梗河一',
  Muphrid: '右摄提一',
  Rasalgethi: '帝座',
  Alcyone: '昴宿六',
  Gomeisa: '南河二',
  Aludra: '弧矢二',
  Porrima: '东上相',
  Vindemiatrix: '东次相',
  Gienah: '轸宿一',
  Algorab: '轸宿三',
  Sadr: '天钩五',
  Sheliak: '渐台二',
  Sulafat: '渐台三',
  Tarazed: '河鼓三',
  Alshain: '河鼓一',
  Albireo: '辇道增八',
  Aljanah: '辇道增七',
  Acrab: '房宿四',
  Dschubba: '房宿三',
  Meissa: '觜宿一',
  Sheratan: '娄宿一',
  Menkar: '天囷一',
  Regor: '天社一',
  Alsephina: '天社三',
  Imai: '十字架四'
}
